import React from 'react';
import styled from 'styled-components';
import AdvanturerGoldYeti from '../../../../assets/images/characters/adventurer-gold-yeti.png';

const EmptyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2rem;
`;

interface IEmptyProps {
    size?: "small" | "medium" | "large";
    customMessage?: string;
}

const Empty = (props: IEmptyProps) => {
    const size = React.useMemo((): number => {
        switch (props.size) {
            case "small":
                return 64;
            case "medium":
                return 128;
            case "large":
                return 256;
            default:
                return 128;
        }
    }, [props.size]);

    const message = React.useMemo(() => {
        if (props.customMessage) {
            return props.customMessage;
        }
        return "No NFTs here";
    }, [props.customMessage]);

    return (
        <EmptyWrapper>
            <img src={AdvanturerGoldYeti} height={size} />
            {message}
        </EmptyWrapper>
    )
}

export default Empty;